import ErrorHandler from '@/plugins/errors/error-handler'
let gateway = process.env.VUE_APP_GATEWAY || 'http://localhost:3000'
let endpoint = process.env.VUE_APP_ENDPOINT || 'http://localhost:3000/api/v1'
let options = {
   mode: 'cors',
   headers: {}
}
let activeRequests = [], minWaitTime = (process.env.VUE_APP_MIN_REQUEST_WAIT_TIME || 1) * 1000

export default class API {
   constructor() {
      this.endpoint = endpoint
      this.errHandler = new ErrorHandler()
   }

   isRequestActive(data) {
      this.clearRequest()

      for (let i = 0; i < activeRequests.length; i++) {
         const req = activeRequests[i];

         if (req.name === data && (new Date().getTime() - req.time) <= minWaitTime) {
            return true
         }
      }

      activeRequests.push({
         name: data,
         time: new Date().getTime()
      })
      return false
   }

   clearRequest() {
      for (let i = 0; i < activeRequests.length; i++) {
         const req = activeRequests[i];
         let diff = (new Date().getTime() - req.time)

         if (diff > minWaitTime) {
            activeRequests.splice(i, 1)
            return;
         }
      }

      return;
   }
   
   fetch(data, route, opt) {
      return new Promise(async (resolve, reject) => {
         if (this.isRequestActive(route)) {
            console.log('Request Active')
            return reject('Active Request. Wait for time to pass')
         }

         try {
            if (Object.keys(data).length > 0) {
               data = JSON.stringify(data)
            } else {
               data = undefined
            }

            let req = this.setOptions({ body: data }, options)
            req = this.setOptions(req, opt)

            if (req.method !== 'GET') {
               req.headers['Content-Type'] = 'application/json'
            }
            if (opt) {
               req = this.setOptions(req, opt)
            }

            let res = await fetch(route, req)
            let body = await res.text()

            if (body === '') { body = undefined }
            if (this.isJson(body)) {
               body = JSON.parse(body)
            }

            if (!res.ok) {
               throw body
            }

            resolve(body)
         } catch (err) {
            await this.errHandler.handleError(err)
            reject(err)
         }
      })
   }

   fetchEndpoint(data, route, opt) {
      return new Promise(async (resolve, reject) => {
         if (this.isRequestActive(route)) {
            console.log('Request Active')
            return reject('Active Request. Wait for time to pass')
         }

         try {
            if (!route) { route = '' }
            if (!opt) { opt = { method: 'POST' } }

            if (Object.keys(data).length > 0) {
               data = JSON.stringify(data)
            } else {
               data = undefined
            }

            let req = this.setOptions({ body: data }, options)
            req = this.setOptions(req, opt)

            req.headers['Content-Type'] = 'application/json'
            if (opt) {
               req = this.setOptions(req, opt)
            }

            let res = await fetch(this.endpoint + route, req)
            let body = await res.text()

            if (body === '') { body = undefined }
            if (this.isJson(body)) {
               body = JSON.parse(body)
            }

            if (!res.ok) {
               throw body
            }

            resolve(body)
         } catch (err) {
            await this.errHandler.handleError(err)
            reject(err)
         }
      })
   }

   fetchEndpointSecure(data, route, opt) {
      return new Promise(async (resolve, reject) => {
         if (this.isRequestActive(route)) {
            console.log('Request Active')
            return reject('Active Request. Wait for time to pass')
         }
         if (!route) { route = '' }
         if (!opt) { opt = { method: 'POST' } }

         try {
            if (Object.keys(data).length > 0) {
               data = JSON.stringify(data)
            } else {
               data = undefined
            }

            let req = this.setOptions({ body: data }, options)
            req = this.setOptions(req, opt)

            // fetch the token and logout user if token is not found
            let token = await $session.get('token')
            if (token) {
               req.headers['Authorization'] = token
            } else {
               Event.$emit('token:not-found', true)
               return reject(false)
            }


            req.headers['Content-Type'] = 'application/json'
            if (opt) {
               req = this.setOptions(req, opt)
            }

            let res = await fetch(this.endpoint + route, req)
            let body = await res.text()

            // if (body === '') { body = undefined }
            if (this.isJson(body)) {
               body = JSON.parse(body)
            }

            if (!res.ok) {
               throw body
            }

            resolve(body)
         } catch (err) {
            await this.errHandler.handleError(err)
            reject(err)
         }
      })
   }

   async fetchRefresh(data, route, opt, count = 0){
      try {
         return await this.fetch(data,route,opt)
      } catch (err) {
         count ++
         if(count < (process.env.VUE_APP_MAX_REQUEST_ITTERATIONS || 3)){
            await utils.sleep(process.env.VUE_APP_REQUEST_REFRESH_WAIT_DURATION || 1)
            return await this.fetch(data, route, opt, count)
         }else{ throw err }
      }
   }

   async fetchEndpointRefresh(data, route, opt, count = 0){
      try {
         return await this.fetchEndpoint(data,route,opt)
      } catch (err) {
         count ++
         if(count < (process.env.VUE_APP_MAX_REQUEST_ITTERATIONS || 3)){
            await utils.sleep(process.env.VUE_APP_REQUEST_REFRESH_WAIT_DURATION || 1)
            return await this.fetchEndpoint(data, route, opt, count)
         }else{ throw err }
      }
   }

   async fetchEndpointSecureRefresh(data, route, opt, count = 0){
      try {
         return await this.fetchEndpointSecure(data,route,opt)
      } catch (err) {
         count ++
         if(count < (process.env.VUE_APP_MAX_REQUEST_ITTERATIONS || 3)){
            await utils.sleep(process.env.VUE_APP_REQUEST_REFRESH_WAIT_DURATION || 1)
            return await this.fetchEndpointSecureRefresh(data, route, opt, count)
         }else{ throw err }
      }
   }


   upload(route, data, name) {
      return new Promise((resolve, reject) => {
         if (this.isRequestActive(route)) {
            console.log('Request Active')
            return reject('Active Request. Wait for time to pass')
         }
         let ajax = new XMLHttpRequest(), token = $session.get('token'), id = this.generateRandomHex(6)
         if (!token) {
            Event.$emit('token:not-found', true)
            return reject(false)
         }

         //TODO: code to store an upload to a session in case it fails it can be restarted
         // send event to notify new upload
         Event.$emit('upload_notification:create', { id, name })

         // on progress
         ajax.upload.addEventListener("progress", (event) => {
            let percent = (event.loaded / event.total) * 100;

            // send event to notify progress
            Event.$emit('upload_notification:progress', {
               id,
               current: this.bytesToSize(event.loaded),
               total: this.bytesToSize(event.total),
               progress: percent
            }, id)
         }, false);

         // on complete
         ajax.addEventListener("load", (event) => {
            Event.$emit('upload_notification:complete', { id })
            resolve(event)
         }, false);

         // on error
         ajax.addEventListener("error", (event) => {
            reject(event)
         }, false);

         // on abort
         ajax.addEventListener("abort", (event) => {
            reject(event)
         }, false);

         // post request
         ajax.open("POST", route);
         ajax.setRequestHeader('Authorization', token)
         ajax.send(data);
      })
   }

   parseRoute(route) {
      return `${gateway}${route}`
   }

   setOptions(data, opt) {
      Object.keys(opt).forEach(function (key) {
         data[key] = opt[key]
      })

      return data
   }

   isJson(data) {
      if (data !== null && data !== undefined && /^[\],:{}\s]*$/.test(data.replace(/\\["\\\/bfnrtu]/g, '@').
         replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').
         replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {
         return true;
      }

      return false
   }

   progressHandler(event) {
      let percent = (event.loaded / event.total) * 100;

      // send event to notify progress
      Event.$emit('upload_notification:progress', {
         id: _id,
         current: this.bytesToSize(event.loaded),
         total: this.bytesToSize(event.total),
         progress: percent
      })
   }

   generateRandomHex(len) {
      let options = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f'], hex = ''
      for (let i = 0; i < len; i++) {
         const letter = options[Math.round(Math.random() * 15)];
         hex += letter
      }

      return hex;
   }

   bytesToSize(bytes) {
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
      if (bytes === 0) return 'n/a'
      const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10)
      if (i === 0) return `${bytes} ${sizes[i]})`
      return `${(bytes / (1024 ** i)).toFixed(1)} ${sizes[i]}`
   }
}